import tinycolor from 'tinycolor2';

import config from '../config/config';

export const getLocationOptions = () => ([
  {value: 'PARTNER', label: 'MX Partner Facility', emoji: getLocationEmoji('PARTNER') },
  {value: 'HOME', label: 'Patient\'s Home', emoji: getLocationEmoji('HOME') },
  // {value: 'GYM', label: 'Patient\'s Gym'},
  // {value: 'WORK', label: 'Patient\'s Workplace'},
  {value: 'VIRTUAL', label: 'Virtual', emoji: getLocationEmoji('VIRTUAL') },
  {value: 'OTHER_MOBILE', label: 'Other Mobile Session', emoji: getLocationEmoji('OTHER_MOBILE') },
]);

export const getLocationColor = locationType => {
  switch (locationType) {
    case 'PARTNER':
      return config().colors.primary; // brand
    case 'HOME':
      return config().colors.secondary; // orange
    case 'VIRTUAL':
      return config().colors.purple; // purple
    case 'OTHER_MOBILE':
      // return tinycolor(config().colors.secondary).lighten(20).toHexString(); // light orange
      return config().colors.warning;
    default:
      return 'rgb(224, 224, 224)'; // light gray
  }
};

export const getLocationEmoji = locationType => {
  switch (locationType) {
    case 'PARTNER':
      return '🏋️';
    case 'HOME':
      return '🏠';
    case 'VIRTUAL':
      return '💻';
    case 'OTHER_MOBILE':
      return '🚗';
    default:
      return '🏋️';
  }
};

export const formatOneLineAddress = addressData => {
  if (!addressData.address_line_1) return '';
  let str = addressData.address_line_1 ? `${addressData.address_line_1 } ` : '';
  str += `${addressData.address_line_2}`;
  str += ', ';
  str += addressData.address_city;
  str += ', ';
  str += addressData.address_state;
  str += ' ';
  str += addressData.address_zip;
  return str;
};
